import { render, staticRenderFns } from "./ClinicChangeStock.vue?vue&type=template&id=34558c4e"
import script from "./ClinicChangeStock.vue?vue&type=script&lang=js"
export * from "./ClinicChangeStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports